<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购管理</el-breadcrumb-item>
      <el-breadcrumb-item>项目Bom</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <el-card class="box-card">
          <!-- 筛选条件 start -->
          <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
            <el-form-item label="">
              <el-select v-model="keywords.productcode" placeholder="请选择" class="select">
                <el-option label="请选择" value="-2"></el-option>
                <el-option
                  v-for="item in nameList" :key="item.Code" :label="item.Name" :value="item.Code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="clicksearch">查询</el-button>
              <el-button type="primary" @click="clickexcel()">导出Excel</el-button>
              <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel" ></TencentyunCosUploadExcel>
              注意：此处是覆盖导入
            </el-form-item>
          </el-form>
          <!-- 筛选条件 end -->

          <!-- 数据列表 start -->
          <el-table v-loading="loading" :data="dataList" ref="dataList" :cell-style="{padding: '0'}" border>
            <el-table-column type="expand" min-width="1%">
              <template slot-scope="props">
                <el-table :data="props.row.Sublist" height="300" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center',padding: '0' }">
                  <el-table-column prop="Materialnumber" label="序号" min-width="4%"></el-table-column>
                  <el-table-column prop="Materialname" label="名称" min-width="7%"></el-table-column>
                  <el-table-column prop="Materialspecifications" label="规格" min-width="15%"></el-table-column>
                  <el-table-column prop="Drawnumber" label="图纸编号" min-width="10%"></el-table-column>
                  <el-table-column prop="Materialcode" label="编码" min-width="7%"></el-table-column>
                  <el-table-column prop="Usenumber" label="用量" min-width="3%"></el-table-column>
                  <el-table-column prop="Danjia" label="单价" min-width="3%"></el-table-column>
                  <el-table-column prop="Zongjia" label="总价" min-width="3%"></el-table-column>
                  <el-table-column prop="Leidiao" label="镭雕" min-width="3%"></el-table-column>
                  <el-table-column prop="Uv" label="UV" min-width="3%"></el-table-column>
                  <el-table-column prop="Amount" label="合计" min-width="3%"></el-table-column>
                  <el-table-column prop="Isdancai" label="是否单采" min-width="3%"></el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="Materialnumber" label="序号" min-width="4%"></el-table-column>
            <el-table-column prop="Materialname" label="名称" min-width="7%"></el-table-column>
            <el-table-column prop="Materialspecifications" label="规格" min-width="12%"></el-table-column>
            <el-table-column prop="Drawnumber" label="图纸编号" min-width="10%"></el-table-column>
            <el-table-column prop="Materialcode" label="编码" min-width="7%"></el-table-column>
            <el-table-column prop="Usenumber" label="用量" min-width="3%"></el-table-column>
            <el-table-column prop="Danjia" label="单价" min-width="4%"></el-table-column>
            <el-table-column prop="Zongjia" label="总价" min-width="4%"></el-table-column>
            <el-table-column prop="Leidiao" label="镭雕" min-width="3%"></el-table-column>
            <el-table-column prop="Uv" label="UV" min-width="3%"></el-table-column>
            <el-table-column prop="Amount" label="合计" min-width="4%"></el-table-column>
            <el-table-column prop="Isdancai" label="是否单采" min-width="3%"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-tab-pane>
      <!-- 清单列表 end -->

  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel
  },
  name: 'MyErp6Bom',
  data () {
    return {
      loading: false,
      activeName: 'first',
      nameList: [],
      // 查询
      keywords: {
        productcode: '103-0000-0009'
      },
      dataList: [],
      rowToogle: null
    }
  },
  mounted () {
    this.apiGetErp6ProjectNameList()
    this.apiGetErp6BomList()
  },
  methods: {
    clickexcel () {
      this.apiExcelErp6Bom()
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportErp6Bom(url)
    },
    toogleExpand (row) {
      const $table = this.$refs.dataList
      this.dataList.map((item) => {
        if (row.Id !== item.Id) {
          $table.toggleRowExpansion(item, false)
        }
      })
      $table.toggleRowExpansion(row)
      this.rowToogle = row
    },
    toogleExpandManual (row) {
      const $table = this.$refs.dataList
      this.dataList.map((item) => {
        if (row.Id == item.Id) {
          $table.toggleRowExpansion(item, true)
        }
      })
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksearch () {
      this.apiGetErp6BomList()
    },
    //为列表获取数据源
    apiGetErp6BomList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productcode: that.keywords.productcode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6BomList, Qs.stringify(data))
        .then(function (response) {
          console.log(response.data)
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    //为下拉框获取数据源
    apiGetErp6ProjectNameList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: '',
        code: '',
        classification: '产品'
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6ProjectNameList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.nameList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    //导出
    apiExcelErp6Bom: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productcode: that.keywords.productcode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelErp6Bom, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    //导入
    apiExcelImportErp6Bom: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productcode: that.keywords.productcode,
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportErp6Bom, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
 .el-table .cell {
      white-space: pre-wrap;
  }
</style>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select1 {
    width: 109px;
    margin-right: 15px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

.productdata3 {
  padding-right: 5px;
}

.box-card{
    margin-top: 5px;
    margin-bottom: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}

</style>
